/** Whether a key name types a search character: a single character other than space. */
export const isSearchCharacter = (key: string) =>
    key.length === 1 && key !== " ";
